import { useEffect, useRef } from 'react'

export function useElementAutoFocus(enabled: boolean) {
  const containerRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (!containerRef.current || !enabled) return

    const hiddenAttribute = 'not([type=hidden])'
    const elementsFound: NodeListOf<HTMLElement> = containerRef.current.querySelectorAll(
      `input:${hiddenAttribute}, select:${hiddenAttribute}, textarea:${hiddenAttribute}`,
    )

    if (!elementsFound) return

    elementsFound[0].focus()
  }, [containerRef, enabled])

  return containerRef
}
